import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostTagsRequest = {
	description: string;
	hexColor: string;
	name: string;
	ownerIds: Array<number>;
};

export type PostTagsResponse = {
	sonarObjectTagId: number;
};

export const postTag = createPostEndpoint<PostTagsRequest, PostTagsResponse>('/api/v3/core/tags/');
